import React, {useState, useEffect} from 'react';
import {Box, Dialog, Grid, IconButton, Slide, Typography} from '@mui/material';
import {fireScreenView, SCREEN_NAMES} from '../../../util/Analytics';
import {Close} from '@mui/icons-material';
import PrimaryButton from '../../../common/StyledComponents/PrimaryButton';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import {theme} from '../../../Theme';
import TertiaryButton from '../../../common/StyledComponents/TertiaryButton';
import {useHistory} from 'react-router-dom';
import BidmiiTextField from '../../../common/StyledComponents/BidmiiTextField';
import SimpleReactValidator from 'simple-react-validator';
import {LazyProposalForm} from '../../../common/LazyLoader';

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children?: ReactNode; direction: "left"; r... Remove this comment to see the full error message
  return <Slide direction="left" ref={ref} {...props} />;
});

const DirectQuoteDialog = (props: $TSFixMe) => {
  useEffect(() => {
    if (props.open) {
      fireScreenView(SCREEN_NAMES.DIRECT_QUOTE_DIALOG);
    }
  }, [props.open]);

  const history = useHistory();
  const [createProposalFormOpen, setCreateProposalFormOpen] = useState(false);
  const [validator] = useState(new SimpleReactValidator());
  const [errors, setErrors] = useState({});
  const [projectTitle, setProjectTitle] = useState(props.defaultTitle || '');

  const actionCloseProposalForm = (type: $TSFixMe) => {
    setCreateProposalFormOpen(false);
    props.toggleDirectQuoteDialog();
  };

  const handleClickContinue = () => {
    if (!validator.fieldValid('projectTitle')) {
      setErrors({...errors, email: true});
      validator.showMessageFor('projectTitle');
      return;
    }
    setErrors({});

    setCreateProposalFormOpen(true);
  };

  return (
    <div>
      <Dialog
        open={props.open ? props.open : false}
        onClose={props.toggleDirectQuoteDialog}
        aria-labelledby="Direct Quote"
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardRefExoticComponent<RefAttributes<unkn... Remove this comment to see the full error message
        TransitionComponent={Transition}
        PaperProps={{style: {borderRadius: 10, maxWidth: 380}}}>
        <IconButton
          onClick={props.toggleDirectQuoteDialog}
          style={{position: 'absolute', right: 0}}
          size="large">
          <Close />
        </IconButton>

        <Box p={3}>
          <Typography
            variant="body1"
            gutterBottom
            style={{fontSize: 22, lineHeight: 1.3}}>
            Send a quote directly to{' '}
            {props.contact
              ? `${props.contact.firstName} ${props.contact.lastName}`
              : 'a customer'}
            .
          </Typography>

          <Box mt={2} mb={3}>
            <BidmiiTextField
              fullWidth
              gutterBottom
              label="Project title*"
              placeholder="What is this quote for?"
              value={projectTitle}
              onChange={(e) => setProjectTitle(e.target.value)}
              helperText={validator.message(
                'projectTitle',
                projectTitle,
                'required',
                {
                  className: 'text-danger',
                },
              )}
            />
          </Box>
          <Grid container justifyContent="space-between">
            <SecondaryButton onClick={props.toggleDirectQuoteDialog}>
              CANCEL
            </SecondaryButton>
            <PrimaryButton
              // disabled={Object.values(directQuoteValues).includes('')}
              onClick={handleClickContinue}>
              CONTINUE
            </PrimaryButton>
          </Grid>
        </Box>

        <Grid
          container
          direction="column"
          alignItems="center"
          style={{borderTop: `1px solid ${theme.palette.gray.border}`}}>
          <Box pt={1.5} pb={3}>
            <Typography variant="subtitle2" align="center">
              Need leads before you can quote?
              <br />
              Go to{' '}
              <TertiaryButton
                onClick={() => history.push('/rfps')}
                style={{marginTop: -2}}>
                Open Jobs
              </TertiaryButton>
              ,<br />
              select a project, and click "bid now"
            </Typography>
          </Box>
        </Grid>
      </Dialog>

      <LazyProposalForm
        open={createProposalFormOpen}
        handleClose={actionCloseProposalForm}
        directQuote
        projectTitle={projectTitle}
        contact={props.contact}
      />
    </div>
  );
};

export default DirectQuoteDialog;
